import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getStoreInvoicePrinter, getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";

import jsPDF from "jspdf";
import "jspdf-autotable";

const B2BChallanComponent = () => {
  const { storeData, brandProfileData, userProfileData } = getUserData();

  let store = storeData;
  let brand = brandProfileData;
  const userProfile = userProfileData;

  const location = useLocation();
  // ✅ Safe fallback if nothing passed
  const { customerOrdersData = [] } = location.state || {};
  const orders = Array.isArray(customerOrdersData)
    ? customerOrdersData
    : [customerOrdersData];

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  
  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  useEffect(() => {
    
    fetchSelectedInvoicePrinter()
  }, [])
  
  

  const downloadChallanPDF = (type = "download") => {
    const doc = new jsPDF("portrait");
    let yPosition = 15;

    orders.forEach((order, index) => {
      if (index !== 0) {
        doc.addPage();
        yPosition = 15;
      }

      // Title
      doc.setFontSize(16);
      doc.text(`Challan No. - ${order.challanNo}`, 105, yPosition, { align: "center" });
      yPosition += 6;

      // Store Info
      doc.setFontSize(12);
      doc.text(capitalize(store.storeName), 105, yPosition, { align: "center" });
      yPosition += 6;
      doc.text(capitalize(store.address.fullAddress), 105, yPosition, { align: "center" });
      yPosition += 6;

      doc.text(`${capitalize(order.customerName)}, ${capitalize(order.customerMobile)}`, 105, yPosition, { align: "center" });
      yPosition += 6;

      doc.text(capitalize(order.customerAddress), 105, yPosition, { align: "center" });
      yPosition += 6;

      // Customer Info
      doc.text(`Date:`, 14, yPosition);
      doc.text(`${order.createdDate?.split("T")[0]}`, 160, yPosition);
      yPosition += 6;

      // Table Data
      const tableData = order.orderItem.map((item) => [
        item.garmentAlias !== ""
          ? capitalize(item.garmentAlias.replace(/_/g, " "))
          : capitalize(item.garmentName.replace(/_/g, " ")),
        item.addOns.map((a) => capitalize(a.serviceName)).join(", "),
        item.bookingType === "PackageBooking"
          ? "-"
          : item.addOns
            .map(
              (a) =>
                `${a.count + a.countGram} ${a.serviceUnit === "Qty" ? "Pcs" : a.serviceUnit
                }`
            )
            .join(", "),
        item.itemGarmentCount,
      ]);

      doc.autoTable({
        startY: yPosition,
        head: [["Name", "Service", "Qty", "IC"]],
        body: tableData,
        theme: "grid",
        styles: { fontSize: 9 },
      });

      yPosition = doc.lastAutoTable.finalY + 10;

      doc.text(
        `Total Garments:`,
        14,
        yPosition
      );
      doc.text(
        `${order.itemGarmentCount}`,
        160,
        yPosition
      );
      yPosition += 6;

      doc.text(
        `Delivery Date: `,
        14,
        yPosition
      );
      doc.text(
        `${order.deliveryOn?.split("T")[0]}`,
        160,
        yPosition
      );
      yPosition += 6;

      doc.text(`Powered By ${capitalize(brand.name)}`, 105, yPosition, { align: "center" });
      
    });

    if (type === "print") {
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => printWindow.print();
      }
    } else {
      doc.save(`B2B_Challan_${new Date().getTime()}.pdf`);
    }
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                     
                    navigate(-1)
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                B2B Challan
              </p>
            </div>
            <div className="mx-4 cursor-pointer" onClick={() => downloadChallanPDF("download")}>
              <img src={"images/printer.png"} style={{ width: 35 }} />
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2">
        <div></div>
        <div className="w-5 ">
          <div className="flex justify-content-center flex-column print-section">

            {orders.map((order) => (
              <div key={order.id} className="print-section p-3">
                <h3 className="text-2xl font-medium text-center line-height-2" style={{textTransform: 'capitalize'}}>Challan No. - {order.challanNo}</h3>

                <p className="text-lg font-medium text-center line-height-2" >{capitalize(store.storeName)}</p>
                <p className="text-md font-medium text-center line-height-2" >{capitalize(store.address.fullAddress)}</p>

                <p className="text-lg font-medium text-center line-height-2" >{capitalize(order.customerName)}, {capitalize(order.customerMobile)}</p>
                <p className="text-lg font-medium text-center line-height-2" >{capitalize(order.customerAddress)}</p>

                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left line-height-2" >
                    <b>Date:</b>
                  </p>
                  <p className="text-md font-normal text-right line-height-2" >
                    {capitalize(order.createdDate?.split("T")[0])}
                  </p>
                </div>
              

                <div className="flex">
                  <p
                    className="text-md font-medium text-left line-height-1"
                    style={{ flex: 2, textTransform: 'capitalize' }}
                  >
                    Name:
                  </p>
                  <p
                    className="text-md font-medium text-left line-height-1"
                    style={{ flex: 2, textTransform: 'capitalize' }}
                  >
                    Service
                  </p>
                  <p className="flex-1 text-md font-medium text-right line-height-1" style={{ textTransform: 'capitalize' }}>
                    Qty
                  </p>
                  <p className="flex-1 text-md font-medium text-right line-height-1" style={{ textTransform: 'capitalize' }}>
                    IC
                  </p>
                </div>

                {order.orderItem.map((item) => (
                  <div className="flex " key={item.id}>
                    <p
                      className="text-md font-normal text-left line-height-1"
                      style={{ flex: 2, textTransform: 'capitalize' }}
                    >
                      {item.garmentAlias !== ""
                        ? capitalize(item.garmentAlias.replace(/_/g, " "))
                        : capitalize(item.garmentName.replace(/_/g, " "))}
                    </p>
                    <p
                      className="text-md font-normal text-left line-height-1"
                      style={{ flex: 2, textTransform: 'capitalize' }}
                    >
                      {item.addOns.map((addOnItem, i) => (
                        <p
                          key={i}
                          className="text-md text-left line-height-1 font-normal" style={{ textTransform: 'capitalize' }}
                        >
                          {capitalize(addOnItem.serviceName)}
                        </p>
                      ))}
                    </p>

                    <p className="flex-1 text-md font-normal text-left line-height-1" style={{ textTransform: 'capitalize' }}>
                      {item.bookingType === "PackageBooking" ? <p
                        className="text-md text-right line-height-1 font-normal" style={{ textTransform: 'capitalize' }}
                      > - </p> :
                        item.addOns.map((addOnItem, i) => (
                          <p
                            key={i}
                            className="text-md text-right line-height-1 font-normal" style={{ textTransform: 'capitalize' }}
                          >
                            {addOnItem.count + addOnItem.countGram}{" "}
                            {addOnItem.serviceUnit === "Qty"
                              ? " Pcs"
                              : addOnItem.serviceUnit}
                          </p>
                        ))}
                    </p>
                    <p className="flex-1 text-md font-normal text-right line-height-1" style={{ textTransform: 'capitalize' }}>
                      {item.itemGarmentCount}
                    </p>
                  </div>
                ))}

                <div className="flex ">
                  <p
                    className="text-md font-medium text-left line-height-2" 
                    style={{ flex: 2, textTransform: 'capitalize' }}
                  >
                    <b>Total Garments :</b>
                  </p>
                  <p
                    className="text-md font-medium text-left line-height-2"
                    style={{ flex: 2, textTransform: 'capitalize' }}
                  ></p>
                  <p
                    className="text-md font-medium text-right line-height-2"
                    style={{ flex: 1, textTransform: 'capitalize' }}
                  >
                    {order.itemGarmentCount}
                  </p>
                </div>
                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left line-height-2" style={{ textTransform: 'capitalize' }}>
                    <b>Delivery Date:</b>
                  </p>
                  <p className="text-md font-medium text-right line-height-2" style={{ textTransform: 'capitalize' }}>
                    {order.deliveryOn?.split("T")[0]}
                  </p>
                </div>
                
                <p className="text-2xl font-medium text-center line-height-2" style={{ textTransform: 'capitalize' }}>Powered By {brand.name}</p>
                <hr />
              </div>
            ))}
             

             
          </div>
        </div>
        <div></div>

        {/*<div className="ml-4 cursor-pointer" onClick={() => window.print()}>
          <img
            src={"Icons/printer.png"}
            style={{
              width: 65,
            }}
          />
        </div>*/}
      </div>
      {/* Menu component */}

      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
              @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default B2BChallanComponent;
